import MotionFadeBetweenElements from "../../../../../../packages/design-system/motion/examples/constellation/motion-fade-between-elements";
import MotionFadeOutListOfElements from "../../../../../../packages/design-system/motion/examples/constellation/motion-fade-out-list-of-elements";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_fade_between_elements from "!!raw-loader!../../../../../../packages/design-system/motion/examples/constellation/motion-fade-between-elements";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_fade_out_list_of_elements from "!!raw-loader!../../../../../../packages/design-system/motion/examples/constellation/motion-fade-out-list-of-elements";
import * as React from 'react';
export default {
  MotionFadeBetweenElements,
  MotionFadeOutListOfElements,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_fade_between_elements,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_fade_out_list_of_elements,
  React
};